import { get } from 'lodash';
import { TemplateWithCommodity } from './types';

export function hasCommoditySection(
  prefix: string,
  template?: TemplateWithCommodity
): boolean {
  if (!template) return false;

  const hasField = (commodity: object) => Boolean(get(commodity, prefix));

  if (template._value.commodityDetails) {
    return hasField(template._value.commodityDetails._value);
  }
  if (template._value.commodities) {
    return Boolean(
      template._value.commodities._value.some(hasField) ||
        template._value.commodities._added?.some(hasField)
    );
  }

  return false;
}
